import { useTranslation } from 'react-i18next';

const STATUS_MAP = {
  DRAFT:       'draft',
  SUBMITTED:   'submitted',
  IN_PROGRESS: 'in-progress',
  APPROVED:    'approved',
  POSTED:      'posted',
  ARCHIVED:    'archived',
};

/**
 * UnifiedStatusBadge — canonical status pill for all lifecycle states.
 * Uses status color tokens from tokens.css.
 * See STATUS_LIFECYCLE.md for the 6 states.
 */
export default function UnifiedStatusBadge({ status }) {
  const { t } = useTranslation();
  const key = STATUS_MAP[status] || 'draft';

  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap"
      style={{
        backgroundColor: `var(--aif-status-${key}-bg)`,
        color: `var(--aif-status-${key}-text)`,
        border: `1px solid var(--aif-status-${key}-border)`,
      }}
      data-testid={`status-badge-${status}`}
    >
      {t(`status.${status?.toLowerCase()}`, { defaultValue: status || 'Unknown' })}
    </span>
  );
}
